// @owners { team: patients }
export const ORDER_TYPE_CONTEXT = {
  ADD_TO_CART: 'Add to cart',
  CART: 'Cart',
  CHECKOUT: 'Checkout',
  POST_CHECKOUT: 'Post checkout',
} as const;

export type OrderTypeContext = (typeof ORDER_TYPE_CONTEXT)[keyof typeof ORDER_TYPE_CONTEXT];
